import { baseUrl_SPB } from '../BaseUrl';
import { parseTemplateRules } from './templateUtils';

const FetchRosterTemplates = async (companyId, locationId, token) => {
  try {
    const response = await fetch(
      `${baseUrl_SPB}/api/v1/rostertemplate/getall?companyId=${companyId}&locationId=${locationId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch roster templates');
    }

    const data = await response.json();

    return (Array.isArray(data) ? data : []).map((item) => ({
      ...item,
      templateRules: parseTemplateRules(item?.templateRules),
    }));
  } catch (error) {
    console.error('Error fetching roster templates:', error);
    return [];
  }
};

export default FetchRosterTemplates;